export default "__VITE_ASSET__C6KEJo9S__"